import type { IPacsHistoryCapabilities } from './pacs-viewer.interfaces';

export interface IHistoryEvents {
    keyId: number;
    typeText: string;
    typeHistory: string;
    agrId: number;
    dat: string;
    doctor: string;
    doctorId: number;
    spec: string;
    sortCode: number;
    depRootName: string;
    depName: string;
    schedExistsForDdOnVisit: number;
    cntProt: number;
    hasSemd: number;
    pacs: IPacsHistoryCapabilities;
    dtSort: Date; // Для сортировки
}

export interface IHistoryMainFilter {
    keyId: number;
    text: string;
    workPlaces: IWorkPlace[];
}
export interface IWorkPlace {
    depId?: number;
    specId?: number;
}
export interface IHistoryFilterItem {
    keyId: number;
    text: string;
    depId?: string;
    specId?: string;
}

export interface IHistoryFilter {
    list: IHistoryFilterItem[] | IHistoryMainFilter[];
    mode: number;
    selectedID: number | null;
    searchText: string;
    loading?: boolean;
}

export enum EHistoryEventsFiltersMode {
    SPEC = 1,
    DOC = 2,
    DEP = 3,
    USL = 4,
}

export interface IHistoryEventsFilterParams {
    beginDate: string | null;
    endDate: string | null;
    mode: number;
}

export interface IHistoryEventList {
    type: string;
    id: number;
    date: Date;
    doctor: string;
    spec: string;
    researchType: string;
}

export interface IHistoryItemHtmlList {
    text: string;
    row_num?: number;
    linkOrHtmlFlag?: 'html' | 'link';
}

export interface IRegistrationData {
    calcStatusText: string;
    doctor: IRegistrationDoctor;
    place: string;
    fullDate: Date;
    target: IRegistrationTarget;
    caseInfo: IRegistrationCaseInfo;
    mainDiagnos: IRegistrationMainDiagnos;
    complDiagnosis: string;
    disabilityText: string;
    secondDiagnos: string;
}

interface IRegistrationDoctor {
    name: string;
    spec: string;
}

interface IRegistrationTarget {
    visType: number;
    visName: string;
}

interface IRegistrationCaseInfo {
    caseText: string;
    caseType: string;
    caseResult: string;
}

interface IRegistrationMainDiagnos {
    mkbCode: string;
    mkbText: string;
    illType: string;
    disp: string;
    travma: string;
    worse: string;
    stage: number;
    crime: string;
}

export interface IProtocolListTable {
    type: string;
    value: string;
}

export interface IProtocolList {
    type: string;
    question: string;
    answer: string;
    bgcolor: string;
    rows: Array<IProtocolListTable>;
}
export interface IHistoryProtocol {
    id: number;
    formId: number;
    date: Date;
    header: string;
    listData: Array<IProtocolList>;
}

export class IHistoryVisit {
    /*
  type: string;
  id: number;
  date: Date;
  regInfo: IRegistrationData;
  protocols: Array<IHistoryProtocol>;
  descriptionVisits: string;
*/
}

export interface IDiagDoctor {
    post: string;
    doctor: string;
}

export interface IHistoryDiag {
    type: string;
    id: number;
    date: Date;
    researchType: string;
    type1: string;
    type2: string;
    type3: string;
    type4: string;
    doctors: Array<IDiagDoctor>;
    results: string;
    protocols: Array<IHistoryProtocol>;
}
